module.exports = __webpack_public_path__ + "static/media/event_trade_cards_and_treasury.02a6ea34.png";